export default {
  en: {
    header: {
      hello: 'Hello,',
      logout: 'Logout'
    },
    sidebar: {
      contracts: 'Contracts',
      customers: 'Customers',
      import: 'Import',
      invoices: "Invoices"
    },
    page: {
      contract: 'Contract',
      asn: 'ASN',
      asn_name: 'ASN Name',
      contract_type: 'Contract Type',
      location: 'Location',
      active_customers: 'Active Customers',
      inactive_customers: 'Inactive Customers',
      active_contracts: 'Active Contracts',
      inactive_contracts: 'Inactive Contracts',
      start_date: 'Start Date',
      status: 'Status',
      active: 'Active',
      closed: 'Closed',
      inactive: 'Inactive',
      customers: 'Customers',
      contracts: 'Contracts',
      search: 'Search',
      email: 'E-mail',
      add_customer: 'Add Customer',
      name: 'Name',
      all: 'All',
      select_contract: 'Select a contract',
      paid: 'Paid',
      unpaid: 'Unpaid',
      cancelled: 'Cancelled',
      refunded: 'Refunded',
      invoices: 'Invoices',
      paid_invoices: 'Paid Invoices',
      unpaid_invoices: 'Unpaid Invoices',
      description: 'Description',
      date: 'Date',
      total: 'Total',
      payment_method: 'Payment Method',
      due_date: 'Due Date',
      actions: 'Actions',
      view: 'View',
      pay: 'Pay',
      export: {
        title: '<b>Import</b> Template',
        description: 'Click here to download the template file that can be used for bulk customer registration.',
        file: {
          title: 'Click below to export spreadsheet:',
          btn: 'Download template',
          footer: 'Last update:'
        }
      },
      import: {
        title: '<b>Import</b> File',
        description: 'Please insert the filled template file here to execute bulk customer registration. All columns must be properly filled in for successful import.',
        send_file: {
          select_file: { 1: '<strong class="font-medium">Select a file</strong> or drag and drop it here.', 2: "Choose the <span class='text- red - 500'>excel</span> file on your computer." },
          upload_file: {
            title: 'Selected file:',
            btn: 'Send'
          }
        },
        error: {
          title: "Import error",
          subtitle: 'Please correct the errors below and try again.',
          line: "Line",
          error: "Error"
        },
        error_partial: {
          title: 'Warning! The import has been partially completed.',
          subtitle: 'Please correct the errors below and try again.'
        },
        file_uploaded: {
          success: {
            title: 'File imported successfully!',
            btn: 'Make another upload'
          },
          alert: {
            title: 'The import has been partially completed.',
            btn: 'Try again'
          },
          error: {
            title: 'Something went wrong!',
            subtitle: 'Check the contents of the imported file.',
            btn: 'Try again'
          }
        }
      },
      export_spreadsheet: 'Export data',
      last_login: 'Last login',
      last_update: 'Last update',
      external_id: 'External ID',
      grace_period_end_at: 'Grace Period End At'
    },
    customer: {
      status_title: 'Change Customer Status',
      button_deactivate: 'Disable',
      button_activate: 'Activate',
      text_deactivate: 'Are you sure you want to deactivate this customer?',
      text_activate: 'Are you sure you want to activate this customer?',
      add_title: 'Add new Customer',
      button_add: 'Add'
    }
  },
  pt: {
    header: {
      hello: 'Olá,',
      logout: 'Sair'
    },
    sidebar: {
      contracts: 'Contratos',
      customers: 'Clientes',
      import: 'Importar',
      invoices: "Invoices"
    },
    page: {
      contract: 'Contrato',
      asn: 'ASN',
      asn_name: 'Nome ASN',
      contract_type: 'Tipo de Contrato',
      location: 'Localização',
      active_customers: 'Clientes Ativos',
      inactive_customers: 'Clientes Inativos',
      active_contracts: 'Contratos Ativos',
      inactive_contracts: 'Contratos Inativos',
      start_date: 'Data Início',
      status: 'Status',
      active: 'Ativo',
      closed: 'Cancelado',
      inactive: 'Inativo',
      customers: 'Clientes',
      contracts: 'Contratos',
      search: 'Buscar',
      email: 'E-mail',
      add_customer: 'Add Cliente',
      name: 'Nome',
      all: 'Todos',
      select_contract: 'Selecione um contrato',
      paid: 'Paid',
      unpaid: 'Unpaid',
      cancelled: 'Cancelled',
      refunded: 'Refunded',
      invoices: 'Invoices',
      paid_invoices: 'Paid Invoices',
      unpaid_invoices: 'Unpaid Invoices',
      description: 'Description',
      date: 'Date',
      total: 'Total',
      payment_method: 'Payment Method',
      due_date: 'Due Date',
      actions: 'Actions',
      view: 'View',
      pay: 'Pay',
      export: {
        title: 'Modelo de <b>Importação</b>',
        description: 'Clique aqui e baixe o arquivo template que poderá ser utilizado para registro de clientes em lote.',
        file: {
          title: 'Clique abaixo para exportar planilha:',
          btn: 'Baixar template',
          footer: 'Última atualização:'
        }
      },
      import: {
        title: 'Arquivo de <b>Importação</b>',
        description: 'Insira aqui o arquivo template já preenchido para executar o registro de clientes em lote. Todos as colunas deverão estar devidamente preenchidas para execução da importação com sucesso.',
        send_file: {
          select_file: { 1: '<strong class="font-medium">Selecione um arquivo</strong> ou arraste e solte aqui.', 2: "Escolha o arquivo <span class='text- red - 500'>excel</span> no seu computador." },
          upload_file: {
            title: 'Arquivo selecionado:',
            btn: 'Enviar'
          }
        },
        error: {
          title: "Erro na importação",
          subtitle: 'Corrija os erros abaixo e tente novamente.',
          line: "Linha",
          error: "Erro"
        },
        error_partial: {
          title: 'Atenção! A importação foi feita parcialmente.',
          subtitle: 'Corrija os erros abaixo e tente novamente.'
        },
        file_uploaded: {
          success: {
            title: 'Arquivo importado com sucesso!',
            btn: 'Realizar outro envio'
          },
          alert: {
            title: 'A importação foi feita parcialmente.',
            btn: 'Tentar novamente'
          },
          error: {
            title: 'Algo deu errado!',
            subtitle: 'Por favor, verifique o conteúdo do arquivo importado.' ,
            btn: 'Tentar novamente'
          }
        }
      },
      export_spreadsheet: 'Exportar dados',
      last_login: 'Último login',
      last_update: 'Última atualização',
      external_id: 'ID Externo',
      grace_period_end_at: 'Fim do Período de Carência'
    },
    customer: {
      status_title: 'Alterar Status do Cliente',
      button_deactivate: 'Desativar',
      button_activate: 'Ativar',
      text_deactivate: 'Tem certeza de que deseja desativar este cliente?',
      text_activate: 'Tem certeza de que deseja ativar este cliente?',
      add_title: 'Adicionar novo Cliente',
      button_add: 'Adicionar'
    }
  },
  es: {
    header: {
      hello: 'Hola,',
      logout: 'Salir'
    },
    sidebar: {
      contracts: 'Contratos',
      customers: 'Clientes',
      import: 'Importar',
      invoices: "Invoices"
    },
    page: {
      contract: 'Contrato',
      asn: 'ASN',
      asn_name: 'Nombre ASN',
      contract_type: 'Tipo de Contrato',
      location: 'Localización',
      active_customers: 'Clientes Activos',
      inactive_customers: 'Clientes Inactivos',
      active_contracts: 'Contratos Activos',
      inactive_contracts: 'Contratos Inactivos',
      start_date: 'Fecha de inicio',
      status: 'Status',
      active: 'Activo',
      closed: 'Cerrado',
      inactive: 'Inactivo',
      customers: 'Clientes',
      contracts: 'Contratos',
      search: 'Buscar',
      email: 'E-mail',
      add_customer: 'Add Cliente',
      name: 'Nombre',
      all: 'Todos',
      select_contract: 'Seleccione un contrato',
      paid: 'Paid',
      unpaid: 'Unpaid',
      cancelled: 'Cancelled',
      refunded: 'Refunded',
      invoices: 'Invoices',
      paid_invoices: 'Paid Invoices',
      unpaid_invoices: 'Unpaid Invoices',
      description: 'Description',
      date: 'Date',
      total: 'Total',
      payment_method: 'Payment Method',
      due_date: 'Due Date',
      actions: 'Actions',
      view: 'View',
      pay: 'Pay',
      export: {
        title: '<b>Importar modelo</b>',
        description: 'Haga clic aquí y descargue el archivo de plantilla que se puede utilizar para el registro de clientes por lotes.',
        file: {
          title: 'Haga clic a continuación para exportar la hoja de cálculo:',
          btn: 'Descargue archivo',
          footer: 'Última actualización:'
        }
      },
      import: {
        title: '<b>Importar archivo</b>',
        description: 'Inserte aquí el archivo de plantilla completo para realizar el registro de clientes por lotes. Todas las columnas deben completarse correctamente para ejecutar correctamente la importación.',
        send_file: {
          select_file: { 1: '<strong class="font-medium">Seleccione un archivo</strong> o arrástrelo y suéltelo aquí.', 2: "Elija el archivo <span class='text- red - 500'>excel</span> en su computadora." },
          upload_file: {
            title: 'Archivo seleccionado:',
            btn: 'Enviar'
          }
        },
        error: {
          title: "Error de importación",
          subtitle: 'Corrija los errores a continuación y vuelva a intentarlo.',
          line: "Línea",
          error: "Error"
        },
        error_partial: {
          title: '¡Atención! La importación se realizó parcialmente.',
          subtitle: 'Corrija los errores a continuación y vuelva a intentarlo.'
        },
        file_uploaded: {
          success: {
            title: '¡Archivo importado exitosamente!',
            btn: 'Haz otra carga'
          },
          alert: {
            title: 'La importación se realizó parcialmente.',
            btn: 'Intentar nuevamente'
          },
          error: {
            title: '¡Algo salió mal!',
            subtitle: 'Verifique el contenido del archivo importado.',
            btn: 'Intentar nuevamente'
          }
        }
      },
      export_spreadsheet: 'Exportar datos',
      last_login: 'Último acceso',
      last_update: 'Última actualización',
      external_id: 'Identificación externa',
      grace_period_end_at: 'Fin del período de gracia'
    },
    customer: {
      status_title: 'Cambiar el estado del cliente',
      button_deactivate: 'Desactivar',
      button_activate: 'Activar',
      text_deactivate: '¿Está seguro de que desea desactivar este cliente?',
      text_activate: '¿Está seguro de que desea activar este cliente?',
      add_title: 'Agregar nuevo cliente',
      button_add: 'Agregar'
    }
  }
};
